/**
 * The form helper for handling validation of each individual registration step.
 * Handles the process of invalidating/validating multi-step forms by setting the
 * overall form as dirty as well as individual fields.
 */
App.factory('formHelper', ['$http', '$q', function($http, $q) {
    var formHelper = {};

    /**
     * A helper method to pass in a particular page's form to the formHelper
     * so that all validation rules can pass by it.
     */
    formHelper.setForm = function(form) {
        formHelper.form = form;
    };

    /**
     * A basic wrapper around helper form validation which handles enabling/disabling
     * the next/previous step.
     */
    formHelper.validateForm = function($scope, ngForm, step, setDirty, callback) {
        void 0;

        // remove previous ajax error(s)
        //$scope.bindings.ajaxError = '';
        if (!$scope.serverErrors[ngForm.$name]) {
            $scope.serverErrors[ngForm.$name] = { fields: {}, msg: null };
        }
        $scope.serverErrors[ngForm.$name].msg = null;

        formHelper
            ._validateForm($scope, ngForm, step, setDirty)
            .then(function(response) {
                void 0;
                void 0;
                void 0;
                void 0;
                void 0;
                void 0;

                formHelper.validateFormCallback($scope, ngForm, response, callback);
            }, function(response) {
                void 0;
                void 0;
                void 0;
                void 0;
                void 0;
                void 0;

                formHelper.validateFormCallback($scope, ngForm, response, callback);
            });
    };

    /**
     * Handle the promise response from the form validator to determine
     * whether or not we should be enabling or disabling the next step button.
     */
    formHelper.validateFormCallback = function($scope, ngForm, response, callback) {
        // check if validation passed
        void 0;

        if (!response.code || response.code != 200) {
            // set ajax error on the form
            if (response.msg) {
                $scope.serverErrors[ngForm.$name].msg = response.msg;
            } else {
                $scope.serverErrors[ngForm.$name].msg = 'An unknown server error occurred.';
            }

            void 0;
            callback(false);
        } else {
            void 0;
            callback(true);
        }
    };

    /**
     * Handle manually triggering errors on form fields.
     */
    formHelper.setError = function($scope, field, key, error, notServerError) {
        var form;

        void 0;

        if (typeof formHelper.form.fieldMap[field] == 'undefined') {
            void 0;
            return false;
        }

        // get the appropriate form
        form = formHelper.form.fieldMap[field];

        // with the scope, update the form
        if (typeof $scope[form] == 'undefined') {
            void 0;
            return false;
        }

        if (typeof $scope[form][field] == 'undefined') {
            void 0;
        }

        // also set the field as invalid
        void 0;
        $scope[form][field].$setValidity(key, false);

        // also set the overall form as invalid
        void 0;
        $scope[form].$setValidity(field, false);

        // only apply server errors where applicable
        if (notServerError != true) {
            // set the form error message
            if (typeof $scope.serverErrors[form] == 'undefined') {
                $scope.serverErrors[form] = { fields: {}, msg: null };
            }

            if (typeof $scope.serverErrors[form].fields[field] == 'undefined') {
                $scope.serverErrors[form].fields[field] = {};
            }
            $scope.serverErrors[form].fields[field][key] = error;

            void 0;
            void 0;
        }

        // return the form name so we can switch to it if need be
        return form;
    };

    /**
     * Standard error response when the form contains errors.
     */
    formHelper.invalidForm = function() {
        var deferred = $q.defer();
        void 0;
        deferred.reject({ code: 500, msg: 'The form appears to contain errors.' });
        return deferred.promise;
    };

    /**
     * Handles clearing a specific field's custom errors. We can specify whether
     * the error must come from the server errors list first before attempting
     * to remove more generic errors.
     */
    formHelper.clearError = function($scope, field, serverOnly) {
        var serverErrorFound = false,
            formName,
            size,
            key;

        void 0;
        void 0;

        if (typeof formHelper.form.fieldMap[field] == 'undefined') {
            void 0;
            return false;
        }

        formName = formHelper.form.fieldMap[field];

        void 0;
        void 0;

        if ($scope.serverErrors[formName]) {
            void 0;
            void 0;
        }

        // now handle server errors specifically
        if (typeof $scope.serverErrors[formName] != 'undefined') {
            if (typeof $scope.serverErrors[formName].fields[field] != 'undefined') {
                // clear errors on the field
                delete $scope.serverErrors[formName].fields[field];

                serverErrorFound = true;
            }

            // if all errors cleared, remove overall server error messaging
            size = 0;
            for (key in $scope.serverErrors[formName].fields) {
                if ($scope.serverErrors[formName].fields.hasOwnProperty(key)) {
                    size++;
                }
            }

            if (size == 0) {
                $scope.serverErrors[formName].msg = null;
            }
        }

        // now handle clearing errors directly on the form
        if (!serverOnly || serverErrorFound) {
            formHelper._clearError($scope[formName], field);
        }

        // apply changes
        setTimeout(function() { $scope.$apply(); }, 0);
    };

    /**
     * Before we trigger validation, we first remove any old form errors from
     * displaying.
     */
    formHelper.clearErrors = function(ngForm) {
        void 0;
        void 0;

        formHelper._clearErrors(ngForm);

        setTimeout(function() { $scope.$apply(); }, 0);
    };

    /**
     * Given a scope and a field, determine the parent form and clear all errors.
     */
    formHelper.clearParentErrors = function($scope, field) {
        var formName;

        void 0;

        if (typeof formHelper.form == 'undefined' || typeof formHelper.form.fieldMap[field] == 'undefined') {
            void 0;
            return false;
        }

        formName = formHelper.form.fieldMap[field];

        void 0;
        void 0;
        void 0;

        // handle clearing errors on the form
        formHelper._clearErrors($scope[formName]);

        // also remove custom errors
        if (typeof $scope.serverErrors[formName] != 'undefined') {
            if (typeof $scope.serverErrors[formName].fields != 'undefined') {
                $scope.serverErrors[formName].fields = {};
                $scope.serverErrors[formName].msg = null;
            }
        }

        // apply changes
        setTimeout(function() { $scope.$apply(); }, 0);
    };

    /**
     * Given the scope, a deferred, and a response, handle generating a
     * response error message and flag any erroneous fields with their
     * accompanying validation errors.
     */
    formHelper.generateRejectResponse = function($scope, deferred, response) {
        var field,
            key;

        if (response.errors) {
            // what type(s) of errors do we have?
            for (field in response.errors) {
                for (key in response.errors[field]) {
                    formHelper.setError($scope, field, key, response.errors[field][key]);
                }
            }

            deferred.reject({
                code: 500,
                msg: 'Errors were found in the form.'
            });
        } else if (response.msg) {
            deferred.reject({
                code: 500,
                msg: response.msg
            });
        } else {
            deferred.reject({
                code: 500,
                msg: 'An unknown error has occurred on the backend. Please try again.'
            });
        }
    };

    /**
     * The validation method which passes off work to individual form validation
     * helper methods when necessary.
     */
    formHelper._validateForm = function($scope, ngForm, step, setDirty) {
        var stepFixed = step.charAt(0).toUpperCase() + step.slice(1),
            method = 'validate' + stepFixed,
            field,
            i;

        void 0;
        void 0;
        void 0;
        void 0;
        void 0;

        // handle any additional validation via deferreds
        return formHelper.form[method]($scope, ngForm);
    };

    /**
     * Underlying method to clear errors.
     */
    formHelper._clearErrors = function(ngForm) {
        var field;

        void 0;
        void 0;

        // remove any pre-existing form errors
        for (field in ngForm) {
            formHelper._clearError(ngForm, field);
        }

        void 0;
        ngForm.$valid = true;
        ngForm.$invalid = false;
    }

    /**
     * Given a form and a field, clear the error.
     */
    formHelper._clearError = function(ngForm, field) {
        var key;

        if (ngForm[field] && typeof ngForm[field].$error != 'undefined') {
            void 0;

            for (key in ngForm[field].$error) {
                void 0;
                ngForm[field].$setValidity(key, true);
            }

            ngForm.$setValidity(field, true);
        }
    }

    return formHelper;
}]);
